module.exports = __webpack_public_path__ + "static/ImpactLabelReversed-8414fcaaef584df99af84da29fff977b.ttf";